import get from 'lodash/get';
import * as productIndexSectionActions from './../action_creators/product_index_section_action_creators';
import ProductIndexSectionModel from '../../models/product_index_section_model';
import notFoundActionCreator from '../../redux/action_creators/not_found_status_action_creator';
import log from '../../services/logger_service';

export default function fetchProductDetail(params, store) {
  return function firstDispatch(dispatch) {
    const state = store.getState();

    if (get(state, 'config.site') === 'fastcompany') {
      dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
    }

    dispatch(productIndexSectionActions.productIndexSectionLoading({}, store));
    return ProductIndexSectionModel.fetch(params, store)
      .then(function handleProductDetailData(ProductData) {
        dispatch(
          productIndexSectionActions.productIndexSectionLoaded(
            ProductData.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status.code') || 500;

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
        }

        dispatch(
          productIndexSectionActions.productIndexSectionLoadError(err, store)
        );

        log.error(err, `Error in product actions, message: ${err.message}`);
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/async_product_index_section_actions.js